const shippingCalculator = {
  postalCodeForm: document.querySelector('.shipping-calculator form'),
  postalCodeField: document.querySelector('.shipping-calculator form input'),
  resetBtn: document.querySelector('.shipping-calculator .reset-button'),
  boxResults: document.querySelector('.shipping-calculator .shipping-calculator-results'),

  postalCodeMask: (event) => {
    let value = event.target.value.replace(/\D/g, ''); // Remove non-digit characters
    if (value.length > 5) {
      value = value.slice(0, 5) + '-' + value.slice(5, 8);
    }
    event.target.value = value;
  },
  formActions: () => {
    shippingCalculator.resetBtn.addEventListener('click', function() {
      shippingCalculator.boxResults.innerHTML = "";
      shippingCalculator.postalCodeField.value = "";
      shippingCalculator.postalCodeField.focus()
    })

    document.querySelector(".shipping-calculator #cep").addEventListener("input", shippingCalculator.postalCodeMask)

    shippingCalculator.postalCodeForm.addEventListener("submit", (e) => shippingCalculator.formSubmit(e))
  },
  getUserShippingRates: async (postalCodeValue, state) => {    
    await fetch(`/cart/prepare_shipping_rates?shipping_address[zip]=${postalCodeValue}&shipping_address[country]=brazil&shipping_address[province]=${state}`, {
      "body": null,
      "method": "POST",
      "mode": "cors",
      "credentials": "include"
    });
    
    const response = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${postalCodeValue}&shipping_address[country]=brazil&shipping_address[province]=${state}`, {
      "body": null,
      "method": "GET",
      "mode": "cors",
      "credentials": "include"
    })
    const data = await response.json();

    shippingCalculator.buildHtml(data)
  },
  buildHtml: data => {
    const shipping_rates = data?.shipping_rates

    if(!shipping_rates || shipping_rates?.error) {
      shippingCalculator.boxResults.innerHTML = `<small class'error-message'>
        ${shipping_rates?.error.length 
          ? "Erro: " + shipping_rates?.error[0] 
          : "Houve um problema ao calcular suas taxas de frete! Por favor prossiga para o checkout e tente novamente!"
        }
      </small>`
      
      return
    }
  
    let shippingOptionsHtml = ''
    
    if(shipping_rates?.length) {   
      shippingCalculator.boxResults.classList.remove("no-results")       
      shipping_rates.forEach(shippingOption => {
        shippingOptionsHtml += `<p class="option-item">
          <span class="option-name">${shippingOption.name}</span>
          <span class="option-price">${shippingOption.price == "0.00" ? "Grátis" : `R$ ${shippingOption.price.replace(".",",")}`}</span>
        </p>`
      })
    } else {
      shippingCalculator.boxResults.classList.add("no-results")
      shippingOptionsHtml = "<span class='no-results-message'>Nenhum resultado encontrado para esse CEP! Por favor, certifique-se que o produto foi adicionado ao carrinho e que o seu navegador tenha permissão para acessar sua localização</span>"
    }
  
    shippingCalculator.boxResults.innerHTML = shippingOptionsHtml
  },
  formSubmit: async (e) => {
    e.preventDefault()
    
    const postalCodeValue = shippingCalculator.postalCodeField.value
    
    if(!navigator.geolocation) alert("Geolocalização não é suportada neste navegador.");
  
    navigator.geolocation.getCurrentPosition(function(position) {
      const { latitude, longitude } = position.coords
      
      // Faz uma solicitação para a API do OpenStreetMap Nominatim
      fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`)
      .then(response => response.json())
      .then(async data => {
        const { state } = data.address

        await shippingCalculator.getUserShippingRates(postalCodeValue, state)
      })
    }, function(error) {
      if (error.code == error.PERMISSION_DENIED) {
        alert("Geolocalização negada, por favor habilite nas configurações do navegador");
      }
    });
  },
  init: () => {
    shippingCalculator.formActions()
  }
}

shippingCalculator.init()